export const listProductType = {
  PRODUCT: '製品',
  SERVICE: 'サービス',
  SOLUTION: 'ソリューション',
  PROJECT: '案件登録申込',
};
